<template>
  <figure
    :class="['zg-video', {
      'zg-video--with-background': background,
      [`zg-video--background-${background}`]: background,
      [`zg-video--size-${size}`]: size
    }]"
  >
    <div
      class="thumbnail"
      @click="showVideo = !showVideo"
    >
      <zg-image
        v-bind="image"
        lazy-load
      />

      <zg-transition-fade>
        <div
          v-if="!showVideo"
          class="play"
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M29 14.2679C30.3333 15.0378 30.3333 16.9622 29 17.7321L11 28.1244C9.66666 28.8942 8 27.9319 8 26.3923L8 5.60769C8 4.06809 9.66667 3.10584 11 3.87564L29 14.2679Z" />
          </svg>
        </div>

        <iframe
          v-else
          :src="url"
          width="100%"
          height="100%"
          frameborder="0"
          allow="autoplay"
          autoplay="true"
          allowfullscreen="true"
        />
      </zg-transition-fade>
    </div>

    <div
      v-if="title"
      class="content"
    >
      <h4>
        {{ title }}
      </h4>

      <span v-if="date">
        {{ date }}
        <span v-if="author">, {{ author }}</span>
      </span>
    </div>
  </figure>
</template>

<script>
  import ZgImage from '../ZgImage/ZgImage'
  import ZgTransitionFade from '../ZgTransitionFade/ZgTransitionFade'

  export default {
    name: 'ZgVideo',
    components: {
      ZgTransitionFade,
      ZgImage
    },
    props: {
      title: {
        type: String,
        required: false,
        default: null
      },
      date: {
        type: String,
        required: false,
        default: null
      },
      author: {
        type: String,
        required: false,
        default: null
      },
      image: {
        type: Object,
        required: true
      },
      url: {
        type: String,
        required: true
      },
      background: {
        type: String,
        required: false,
        default: null,
        validator: value => [
          'beige',
          'white'
        ].includes(value)
      },
      size: {
        type: String,
        required: false,
        default: 'medium',
        validator: value => [
          'medium',
          'large'
        ].includes(value)
      }
    },
    data: () => ({
      showVideo: false
    })
  }
</script>

<style lang="scss" scoped>
  .zg-video {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .thumbnail {
      position: relative;
      width: 100%;
      border-radius: radius(large);
      overflow: hidden;
      cursor: pointer;

      ::v-deep img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 1;
      }

      .play {
        position: absolute;
        top: 50%;
        left: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: rem(48px);
        height: rem(48px);
        background-color: color(primary-500);
        transform: translate(-50%, -50%);
        border-radius: 100%;
        z-index: 2;

        svg {
          width: rem(24px);
          height: rem(24px);
        }
      }

      iframe {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 3;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: rem(20px);
      padding: rem(20px) 0;

      h4 {
        @include type-title-m;

        margin: 0;
      }

      span {
        @include type-body-s;

        color: color(gray-500);
        margin: 0;
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // background
  // ? ----------------------------------------------------------------------

  .zg-video--with-background {
    border-radius: radius(large);

    .thumbnail {
      border-radius: radius(large) radius(large) 0 0;
    }

    .content {
      padding: rem(20px) rem(24px);
    }
  }

  .zg-video--background-white {
    background-color: color(white);
  }

  .zg-video--background-beige {
    background-color: color(beige);
  }

  // ? ----------------------------------------------------------------------
  // size
  // ? ----------------------------------------------------------------------

  .zg-video--size-medium {
    .thumbnail {
      height: rem(210px);

      @include mq(medium) {
        height: rem(210px);
      }
    }
  }

  .zg-video--size-large {
    .thumbnail {
      height: rem(210px);

      @include mq(medium) {
        height: rem(326px);
      }
    }
  }
</style>
